import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M19 2.6c.279-.058.641-.11 1.017-.016l.162.05.2.087a2 2 0 0 1 .901.9l.086.201.05.161c.094.376.043.738-.015 1.017-.07.329-.195.733-.334 1.182l-4.09 13.295c-.178.577-.33 1.075-.482 1.448-.138.339-.36.81-.81 1.091a2 2 0 0 1-1.827.152c-.49-.203-.786-.632-.978-.944-.211-.343-.444-.809-.714-1.35l-2.59-5.18a5.928 5.928 0 0 0-.09-.175l-.003-.004c-.031-.017-.075-.039-.165-.084l-5.193-2.597c-.54-.27-1.006-.502-1.35-.713-.311-.192-.74-.49-.943-.98a2 2 0 0 1 .151-1.825c.281-.45.752-.673 1.091-.811.374-.152.872-.304 1.45-.482l13.293-4.09c.45-.139.854-.263 1.183-.333Zm.411 1.958c-.218.045-.518.137-1.006.287L5.111 8.935c-.614.19-1.01.312-1.283.422l-.057.026.052.035c.25.154.621.34 1.197.628l5.013 2.507 4.414-4.414a1 1 0 0 1 1.414 1.415l-4.414 4.412 2.508 5.014c.288.575.474.947.628 1.197l.033.05.027-.055c.11-.272.233-.668.421-1.282l4.091-13.295.002-.006c.15-.485.24-.783.285-1 .003-.013.003-.026.005-.037l-.036.006Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "paper-plane"}) } }